export const HO_FAVICONS = {
  16: 'https://cdn-imgix-open.headout.com/logo/ho-favicon-16.png',
  32: 'https://cdn-imgix-open.headout.com/logo/ho-favicon-32.png',
  48: 'https://cdn-imgix-open.headout.com/logo/ho-favicon-48.png',
};

export const FAVICON_LONDON_THEATRE_TICKETS =
  'https://images.prismic.io/mystique/43d0bf7f-2955-413b-a266-8fc62dd9c933_shows-favicon.png?auto=compress,format';
